import { GlobalResponseObject } from '../../../common';
import { RoleModel } from './role.model';

export class RolesResponse extends GlobalResponseObject {
    data?: RoleModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RoleModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}